import { render, staticRenderFns } from "./DPagination.vue?vue&type=template&id=05a63c96&"
import script from "./DPagination.vue?vue&type=script&lang=js&"
export * from "./DPagination.vue?vue&type=script&lang=js&"
import style0 from "./DPagination.vue?vue&type=style&index=0&id=05a63c96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports